/** Inclusive date range → array of ISO date strings (YYYY-MM-DD). */
export function datesInRange(dateStart, dateEnd) {
  if (!dateStart || !dateEnd || dateEnd < dateStart) return [];
  const out = [];
  const cursor = new Date(`${dateStart}T12:00:00Z`);
  const end = new Date(`${dateEnd}T12:00:00Z`);
  while (cursor <= end) {
    out.push(cursor.toISOString().slice(0, 10));
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }
  return out;
}

export function dayCount(dateStart, dateEnd) {
  return datesInRange(dateStart, dateEnd).length;
}
